import React from 'react';
import { FaGithub, FaLinkedin, FaBloggerB, FaHeart } from 'react-icons/fa';

const footerLinks = [
  { name: 'About',      href: '#about'      },
  { name: 'Stack',      href: '#skills'     },
  { name: 'Projects',   href: '#projects'   },
  { name: 'Experience', href: '#experience' },
  { name: 'Contact',    href: '#contact'    },
];

const socialLinks = [
  { icon: FaGithub,   href: 'https://github.com/atmanad',                     label: 'GitHub'   },
  { icon: FaLinkedin, href: 'https://www.linkedin.com/in/atmanad/',             label: 'LinkedIn' },
  { icon: FaBloggerB, href: 'https://anewbieprogrammer.blogspot.com/',          label: 'Blog'     },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleNavClick = (href) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{
      position: 'relative',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      background: 'rgba(8,15,23,0.8)',
      backdropFilter: 'blur(8px)',
    }}>
      {/* Top glow line */}
      <div style={{
        position: 'absolute', top: -1, left: '20%', right: '20%', height: '1px',
        background: 'linear-gradient(90deg, transparent, rgba(0,242,255,0.3), transparent)',
      }} />

      <div className="container-custom py-12">
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '2rem',
          alignItems: 'center',
        }}>
          {/* Top row */}
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '1.5rem',
          }}>
            {/* Logo */}
            <a
              href="#home"
              onClick={(e) => { e.preventDefault(); handleNavClick('#home'); }}
              style={{ textDecoration: 'none' }}
            >
              <span style={{
                fontFamily: 'Sora, sans-serif', fontWeight: 800, fontSize: '1.25rem',
                letterSpacing: '-0.03em', color: '#dce3f0',
              }}>
                ATMAN<span style={{ color: '#00f2ff' }}>.</span>
              </span>
            </a>

            {/* Nav */}
            <nav style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1.5rem' }}>
              {footerLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  style={{
                    fontFamily: 'JetBrains Mono, monospace',
                    fontSize: '0.7rem', fontWeight: 500, letterSpacing: '0.06em',
                    color: '#849495', textDecoration: 'none', textTransform: 'uppercase',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = '#00f2ff')}
                  onMouseLeave={(e) => (e.currentTarget.style.color = '#849495')}
                >
                  {link.name}
                </a>
              ))}
            </nav>

            {/* Socials */}
            <div style={{ display: 'flex', gap: '0.75rem' }}>
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    style={{
                      width: 38, height: 38, borderRadius: '8px',
                      background: 'rgba(46,53,63,0.6)',
                      border: '1px solid rgba(255,255,255,0.08)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      color: '#849495', textDecoration: 'none',
                      transition: 'all 0.2s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = 'rgba(0,242,255,0.1)';
                      e.currentTarget.style.borderColor = 'rgba(0,242,255,0.25)';
                      e.currentTarget.style.color = '#00f2ff';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = 'rgba(46,53,63,0.6)';
                      e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)';
                      e.currentTarget.style.color = '#849495';
                    }}
                  >
                    <Icon size={16} />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Bottom */}
          <div style={{
            width: '100%',
            paddingTop: '1.5rem',
            borderTop: '1px solid rgba(255,255,255,0.04)',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '1rem',
          }}>
            <p className="text-mono" style={{ color: '#849495', fontSize: '0.7rem', letterSpacing: '0.04em' }}>
              © {currentYear} Atman Das. All rights reserved.
            </p>
            <p style={{
              color: '#849495', fontSize: '0.78rem',
              display: 'flex', alignItems: 'center', gap: '0.35rem',
            }}>
              Built with{' '}
              <FaHeart size={11} color="#00f2ff" />
              {' '}using React &amp; Tailwind CSS
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
